import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de inseticas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarInoculantes(props) {
  useEffect(() => {
    const title = 'inoculantes.cadastroDeInoculantes';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'inoculantes'}
      insumoEnum={Insumo.INOCULANTE}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'inoculantes.' +
          (props.match.params.id ? 'inoculantesEditadoComSucesso' : 'inoculantesCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'inoculantes.' +
          (props.match.params.id ? 'falhaAoEditarInoculantes' : 'falhaAoCadastrarInoculantes')
      )}
      falhaCarregarMensagem={formatMessage('inoculantes.falhaAoCarregarInoculantes')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarInoculantes));
